import { Message } from "@/components/shared/message";
import { ShieldCheck } from "@/components/shared/icons";

export const BookingPayLater = () => {
  return (
    <Message
      variant="info"
      icon={ShieldCheck}
      title="Book Now, Pay Later ✨"
      message="We only collect payment after the job is completed to give you extra peace of mind! We accept all major credit cards except Visa, as well as PayNow. Payment details will be shared once your booking is confirmed 😊"
    />
  );
};
